<template>
    <div class="row justify-content-center">
        <div class="col-11 col-xs-11 col-md-6">
            <div class="router-nav u-mt2 u-mb2">
                <ion-button shape="round" expand="full" v-on:click="back()">Return</ion-button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    methods : {
        back : function () {
            this.$router.push({name : 'home'});
        }
    }
}
</script>